<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditJobTitle"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editJobTitle"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Job Title</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Job Title Name</label>
              <input
                v-model="jobTitleToEdit.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Reports To:</label>
              <select
                  v-model="jobTitleToEdit.ReportsTo"
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full">
                <option
                    v-for="jobTitle in existingJobTitles"
                    :key="jobTitle.Id"
                    :value="jobTitle.Id"
                >
                  {{ jobTitle.Name }}
                </option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Hierarchy (Use 1 for your highest ranked job title)</label>
              <input
                  v-model="jobTitleToEdit.Hierarchy"
                  required
                  type="number"
                  class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Job Description</label>
              <textarea
                v-model="jobTitleToEdit.Description"
                type="text"
                class="p-2 bg-gray-200 rounded-md w-full"
                rows="4"
                maxlength="500"
                autocorrect="en-US"
              ></textarea>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "CompanySetupEditJobTitle",
  props: ["showEditJobTitle", "jobTitleToEdit", "reload", "existingJobTitles"],
  components: { Loader },
  data() {
    return {
      info: {
        Name: null,
        Description: null,
        ReportsTo: null,
        Hierarchy: ''
      },
      edit_error: null,
      edit_success: null,
      loading: false,
      selectedJobTitleReportingTo: this.value
    };
  },
  watch: {
    selectedJobTitleReportingTo(newVal) {
      this.$emit('input', newVal);
    }
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    editJobTitle() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/edit`,
          JSON.stringify(this.jobTitleToEdit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
              this.info = {
                Name: null,
                Description: null,
              };
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.reload();
              }, 1500);
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 1500);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
            }, 1500);
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
